import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGymRetentionStatsData } from "../../../../redux/prospect-reducers/prospectSlice";
import CalendarLoader from "../../../common-components/CalendarLoader";
import {
  CallIcon,
  EmailIcon,
  PersonIcon,
  ReloadIcon,
  XCircleIcon,
} from "../../../../images/icons/icons";
import {
  getCardIconType,
  getCardsIcon,
  getCardTitle,
} from "../../trainer-member-map/tmeMocksData";
import CommonTable from "../../../common-components/common-tables/CommonTable";
import { fetchApiDataDup3 } from "../../../../redux/reducers/commonApiSlice";

const TMEGymAnalysisDetails = ({
  from,
  userInfoData,
  rowData,
  setModValues,
}) => {
  const dispatch = useDispatch();
  const {
    gymRetentionStats,
    gymRetentionStatsLoading,
    gymRetentionStatsError,
  } = useSelector((state) => state.prospects);
  const { dataDup3, loadingDup3, errorDup3 } = useSelector(
    (state) => state.common
  );

  const iniDatas = {
    pagination: [],
    tbData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    limit: pageLimit,
    page: isPage + 1,
    gym_id: rowData?.gym_id || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [statsData, setStatsData] = useState({});

  const EXCLUDED_KEYS = ["gym_id", "retention_status"];

  function getRetentionData(filters) {
    const { limit, page, ...rest } = filters || {};

    dispatch(
      fetchGymRetentionStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getTrainerwiseData(filters) {
    dispatch(
      fetchApiDataDup3({
        method: "GET",
        endpoint: "/trainer/trainer_report_stats",
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getRetentionData(filters);
  }, []);

  useEffect(() => {
    getTrainerwiseData(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !gymRetentionStatsLoading &&
      !gymRetentionStatsError &&
      gymRetentionStats?.data
    ) {
      setStatsData(gymRetentionStats.data);
    } else {
      setStatsData({});
    }
  }, [gymRetentionStatsLoading, gymRetentionStatsError, gymRetentionStats]);

  useEffect(() => {
    if (!loadingDup3 && !errorDup3 && dataDup3?.status && dataDup3?.data) {
      setAllDatas((prevs) => ({
        ...prevs,
        tbData: dataDup3.data,
        pagination: dataDup3?.pagination || [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [loadingDup3, errorDup3, dataDup3]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit,
      page: isPage + 1,
    }));
  }, [isPage, pageLimit]);

  if (!gymRetentionStatsLoading && !statsData) {
    return (
      <div className="error-container">
        <p>No data found.</p>
      </div>
    );
  }

  const tbColumns = [
    from !== "tme-gym-analysis-details" && {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 25;

        return (
          <span
            className={`tb-data tb-link ${isLong ? "tb-data-long" : ""}`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen2: true,
                modName2: "tme-analysis-details",
                rowData2: row,
              }))
            }
          >
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "trainer info",
      formatter: (_, row) => {
        const email = row?.trainer_email || null;
        const isEmailLong = email?.length > 15;

        return (
          <>
            {row?.trainer_id ? (
              <div className="tb-flex-col">
                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <PersonIcon />
                  </span>{" "}
                  <span
                    className={`tb-data ${
                      from === "tme-gym-analysis-details" ? "tb-link" : ""
                    }`}
                    onClick={() =>
                      from === "tme-gym-analysis-details" &&
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen2: true,
                        modName2: "tme-analysis-details",
                        rowData2: row,
                      }))
                    }
                  >
                    {row?.trainer_name || "NA"}
                  </span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <CallIcon />
                  </span>{" "}
                  <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
                </div>

                <div className="tb-flex">
                  <span className="tb-data tb-info-icon">
                    <EmailIcon />
                  </span>{" "}
                  <span
                    className={`tb-data lowercase ${
                      isEmailLong ? "tb-data-long" : ""
                    }`}
                  >
                    {row?.trainer_email || "NA"}
                  </span>
                </div>
              </div>
            ) : (
              <span className="tb-data tb-icon">
                <XCircleIcon />
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "total_active_members",
      text: "assigned members",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-success">
            {row?.total_active_members || 0} active
          </span>
        );
      },
    },
    {
      dataField: "total_expired_members",
      text: "lost members",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge not-assigned">
            {row?.total_expired_members || 0} expired
          </span>
        );
      },
    },
    {
      dataField: "current_trainer_avg_rating",
      text: "trainer rating",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-primary">
            {parseFloat(row?.avg_rating || 0).toFixed(1) || 0} ★
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="mr-kpi-grid grid-5 mt30">
        {gymRetentionStatsLoading ? (
          <CalendarLoader daysCount={5} />
        ) : (
          statsData &&
          Object.entries(statsData)?.map(([key, value]) => {
            return (
              !EXCLUDED_KEYS.includes(key) && (
                <div className="mr-kpi-card" key={key}>
                  <div className="mr-kpi-head">
                    <div>
                      <p className="mr-kpi-title">{getCardTitle(key)}</p>
                      <div className="mr-kpi-value-row">
                        <div className="mr-kpi-value">{value || 0}</div>
                      </div>
                    </div>
                    <span
                      className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(
                        key
                      )}`}
                    >
                      {getCardsIcon(key)}
                    </span>
                  </div>
                </div>
              )
            );
          })
        )}
      </div>

      <div className="flex-col-tables-container mt30">
        <div className="tme-tb-header">
          <h3 className="tm-tb-header-title">
            All Trainers ({dataDup3?.pagination?.[0]?.pagination || 0}){" "}
            <button
              className="page-heading-reload-btn"
              onClick={() => getTrainerwiseData(filters)}
              title="Reload"
              type="button"
            >
              <ReloadIcon />
            </button>
          </h3>
        </div>

        <div className="common-table-container tb-bordered">
          <CommonTable
            tableData={allDatas.tbData}
            tablePagination={allDatas.pagination}
            tableColumns={tbColumns}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isLoading={loadingDup3}
          />
        </div>
      </div>
    </>
  );
};

export default TMEGymAnalysisDetails;
